import * as actionTypes from 'containers/Campaigns/CreateEdit/store/action-types';
import { CampaignUpdateActionContextType } from 'utils/campaigns';

export const changeDetailsValue = (value: string, attribute: string) => ({
  type: actionTypes.DETAILS_VALUE_CHANGE,
  payload: { value, attribute },
});

export const finishCreation = () => ({
  type: actionTypes.CREATE_CAMPAIGN_FINISH,
});

export const openCreateCampaignModal = () => ({
  type: actionTypes.CREATE_CAMPAIGN_MODAL_OPEN,
});

export const openEditCampaignModal = (id: string, context: CampaignUpdateActionContextType) => ({
  type: actionTypes.EDIT_CAMPAIGN_MODAL_OPEN,
  payload: { id, context },
});

export const previous = (currentStep: number) => ({
  type: actionTypes.PREVIOUS,
  payload: currentStep - 1,
});

export const setCampaign = (campaign: any) => ({
  type: actionTypes.CAMPAIGN_SET,
  payload: campaign,
});

export const setCurrentStep = (value: number) => ({
  type: actionTypes.CURRENT_STEP_SET,
  payload: value,
});

export const setSavingError = (value: string) => ({
  type: actionTypes.SAVING_ERROR_SET,
  payload: value,
});

export const setShow = (value: boolean) => ({
  type: actionTypes.SHOW_SET,
  payload: value,
});

export const reset = () => ({
  type: actionTypes.RESET,
});
